import {
	Box,
	Checkbox,
	FormControl,
	FormErrorMessage,
	FormLabel,
	Input,
	InputGroup,
	InputRightElement,
	Text,
} from "@chakra-ui/react";
import React from "react";
import { COLORS } from "../../../../Helper/Colors";

export const FormInput = ({
	label,
	error,
	errorMsg,
	onCheckBoxChange,
	checkBoxValue,
	isRequired,
	height,
	rightIcon,
	isChekbox,
	inputBgColor = COLORS.light,
	...rest
}) => {
	return (
		<FormControl isInvalid={error} isDisabled={rest.isDisabled || false}>
			<Box display={"flex"} flexDirection={"row"} alignItems={isRequired ? "start" : "center"}>
				{!!isChekbox && (
					<Checkbox
						onChange={onCheckBoxChange}
						value={checkBoxValue}
						defaultChecked
						size={"lg"}
						marginBottom={2}
						colorScheme={"brand"}
						marginRight={1}
					/>
				)}
				<FormLabel htmlFor={rest.name} textTransform='capitalize' marginRight={0}>
					{label}
				</FormLabel>
				{!!isRequired && (
					<Text alignItems={"start"} marginLeft={1} color={COLORS.red}>
						*
					</Text>
				)}
			</Box>
			<InputGroup display={"flex"} alignItems='center'>
				<Input
					backgroundColor={inputBgColor}
					height={height ? height : 12}
					className='custom-input'
					borderColor={COLORS.gray}
					{...rest}
				/>
				{!!rightIcon && (
					<InputRightElement height={height ? height : 12} alignItems='center' justifyContent='center'>
						{rightIcon}
					</InputRightElement>
				)}
			</InputGroup>
			{!!error && <FormErrorMessage>{errorMsg}</FormErrorMessage>}
		</FormControl>
	);
};
